const MUI_PRO_KEY = '33525c06a5769f552b971c6da88b132bT1JERVI6Njk1NTIsRVhQSVJZPTE3MjAyNzA2NzA4NDgsS0VZVkVSU0lPTj0x'

export default MUI_PRO_KEY
